(() => {
  class CozyTabs extends HTMLElement {
    connectedCallback() {
      if (this.events) this.events.abort();
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      this.tabs = [...this.querySelectorAll('[data-cozy-tab]')];
      this.panels = [...this.querySelectorAll('[data-cozy-panel]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index), opts);
        tab.addEventListener('keydown', event => {
          let next = index;
          if (event.key === 'ArrowDown' || event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else return;
          event.preventDefault(); this.select(next); this.tabs[next].focus();
        }, opts);
      });
      this.addEventListener('shopify:block:select', event => {
        const block = event.detail?.blockId;
        const index = this.tabs.findIndex(tab => tab === event.target.closest('[data-cozy-tab]') || (block && tab.id.endsWith('-' + block)));
        if (index >= 0) this.select(index);
      }, opts);
    }
    select(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }
    disconnectedCallback() { this.events?.abort(); }
  }
  class CozyProduct extends HTMLElement {
    connectedCallback() {
      if (this.events) this.events.abort();
      this.events = new AbortController();
      const opts = { signal: this.events.signal };
      const data = this.querySelector('[data-cozy-data]');
      if (!data) return;
      this.data = JSON.parse(data.textContent);
      this.current = this.data.variants.find(variant => variant.id === this.data.initial) || this.data.variants[0];
      if (!this.current) return;
      this.form = this.querySelector('form[action*="/cart/add"]');
      this.items = [...this.querySelectorAll('[data-gallery-item]')];
      this.thumbs = [...this.querySelectorAll('[data-gallery-thumb]')];
      this.fields = [...this.querySelectorAll('[data-cozy-option]')];
      this.qty = Math.max(1, Math.floor(Number(this.querySelector('[data-cozy-quantity]')?.value) || 1));
      this.sticky = this.querySelector('[data-cozy-sticky]');
      this.add = this.querySelector('[data-cozy-add]');
      this.label = this.querySelector('[data-add-label]');
      this.error = this.querySelector('[data-cozy-error]');
      this.fields.forEach((field, index) => field.querySelectorAll('[data-option-value]').forEach(button => button.addEventListener('click', () => this.choose(index, button.dataset.optionValue), opts)));
      this.thumbs.forEach(button => button.addEventListener('click', () => this.showGallery(this.items.findIndex(item => item.dataset.galleryItem === button.dataset.galleryThumb)), opts));
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.moveGallery(-1), opts);
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.moveGallery(1), opts);
      const stage = this.querySelector('[data-cozy-gallery]');
      stage?.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.moveGallery(event.key === 'ArrowRight' ? 1 : -1); }
      }, opts);
      stage?.addEventListener('pointerdown', event => { this.pointer = { x: event.clientX, y: event.clientY }; }, opts);
      stage?.addEventListener('pointerup', event => {
        if (!this.pointer) return;
        const dx = event.clientX - this.pointer.x, dy = event.clientY - this.pointer.y;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.moveGallery(dx < 0 ? 1 : -1);
        this.pointer = null;
      }, opts);
      stage?.addEventListener('pointercancel', () => { this.pointer = null; }, opts);
      this.querySelector('[data-qty-minus]')?.addEventListener('click', () => this.quantity(this.qty - 1), opts);
      this.querySelector('[data-qty-plus]')?.addEventListener('click', () => this.quantity(this.qty + 1), opts);
      const dialog = this.querySelector('[data-size-dialog]');
      this.querySelector('[data-size-open]')?.addEventListener('click', () => dialog.showModal(), opts);
      this.querySelector('[data-size-close]')?.addEventListener('click', () => dialog.close(), opts);
      dialog?.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close(); } }, opts);
      const zoomDialog = this.querySelector('[data-gallery-dialog]');
      const zoomToggle = this.querySelector('[data-zoom-toggle]');
      const zoomScroll = this.querySelector('[data-zoom-scroll]');
      const resetZoom = () => { zoomScroll.classList.remove('is-zoomed'); zoomToggle.textContent = zoomToggle.dataset.zoomIn; zoomToggle.setAttribute('aria-pressed', 'false'); zoomScroll.scrollTo(0, 0); };
      this.querySelector('[data-gallery-zoom]')?.addEventListener('click', () => {
        const source = this.items[this.active]?.querySelector('img');
        if (!source) return;
        const fullImage = this.querySelector('[data-zoom-image]');
        const url = new URL(source.src); url.searchParams.set('width', '2000');
        fullImage.src = url.href; fullImage.alt = source.alt;
        this.querySelector('[data-zoom-caption]').textContent = this.thumbs.find(t => t.dataset.galleryThumb === this.items[this.active].dataset.galleryItem)?.getAttribute('aria-label') || this.data.button;
        resetZoom(); zoomDialog.showModal();
      }, opts);
      zoomToggle?.addEventListener('click', () => {
        const expanded = zoomScroll.classList.toggle('is-zoomed');
        zoomToggle.textContent = expanded ? zoomToggle.dataset.zoomOut : zoomToggle.dataset.zoomIn;
        zoomToggle.setAttribute('aria-pressed', String(expanded));
        if (!expanded) zoomScroll.scrollTo(0, 0);
      }, opts);
      this.querySelector('[data-zoom-close]')?.addEventListener('click', () => zoomDialog.close(), opts);
      zoomDialog?.addEventListener('click', event => { if (event.target === zoomDialog) { const box = zoomDialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) zoomDialog.close(); } }, opts);
      zoomDialog?.addEventListener('close', resetZoom, opts);
      this.form?.addEventListener('submit', event => { event.preventDefault(); this.submit(); }, opts);
      this.querySelector('[data-sticky-add]')?.addEventListener('click', () => this.form.requestSubmit(), opts);
      this.addEventListener('shopify:block:select', event => {
        const block = event.detail?.blockId;
        const item = event.target.closest('[data-gallery-item]') || this.items.find(el => el.dataset.galleryItem === block);
        if (item) this.showGallery(this.items.indexOf(item), true);
      }, opts);
      this.update(false);
      this.buttonObserver = new IntersectionObserver(entries => {
        this.pastButton = !entries[0].isIntersecting && this.add.getBoundingClientRect().top < 0;
        this.syncSticky();
      }, { threshold: 0 });
      this.buttonObserver.observe(this.add);
      const footer = document.querySelector('.plc-footer');
      if (footer) { this.footerObserver = new IntersectionObserver(entries => { this.atFooter = entries[0].isIntersecting; this.syncSticky(); }); this.footerObserver.observe(footer); }
    }
    quantity(value) {
      this.qty = Math.max(1, Math.floor(Number(value) || 1));
      this.querySelector('[data-qty-display]').textContent = this.qty;
      this.querySelector('[data-cozy-quantity]').value = this.qty;
    }
    choose(index, value) {
      const options = [...this.current.options]; options[index] = value;
      let variant = this.data.variants.find(v => v.options.every((option, i) => option === options[i]));
      let adjusted = false;
      if (!variant) { variant = this.data.variants.find(v => v.options[index] === value && v.available); adjusted = true; }
      if (!variant) return;
      this.current = variant;
      const note = this.querySelector('[data-cozy-option-note]');
      note.hidden = !adjusted; note.textContent = adjusted ? this.data.color_note : '';
      this.update(true);
    }
    update(changeUrl) {
      const variant = this.current;
      this.querySelector('[data-cozy-variant]').value = variant.id;
      this.querySelector('[data-cozy-price]').textContent = variant.price_label;
      this.querySelector('[data-cozy-sticky-price]').textContent = variant.price_label;
      const compare = this.querySelector('[data-cozy-compare]');
      compare.textContent = variant.compare > variant.price ? variant.compare_label : '';
      compare.hidden = variant.compare <= variant.price;
      this.add.disabled = !variant.available;
      this.querySelector('[data-sticky-add]').disabled = !variant.available;
      this.label.textContent = variant.available ? this.data.button : this.data.sold_out;
      this.fields.forEach((field, index) => {
        field.querySelector('[data-option-name]').textContent = variant.options[index];
        field.querySelectorAll('[data-option-value]').forEach(button => {
          const chosen = variant.options[index] === button.dataset.optionValue;
          button.classList.toggle('is-selected', chosen); button.setAttribute('aria-pressed', String(chosen));
          button.disabled = index > 0 && !this.data.variants.some(v => v.options[0] === variant.options[0] && v.options[index] === button.dataset.optionValue && v.available);
        });
      });
      const color = variant.options.find(v => v === 'White' || v === 'Black') || 'White';
      this.eligible = this.items.map((item, index) => (item.dataset.color === 'all' || item.dataset.color === color) ? index : -1).filter(i => i >= 0);
      this.thumbs.forEach(button => { button.hidden = button.dataset.color !== 'all' && button.dataset.color !== color; });
      const matching = this.items.findIndex(item => item.dataset.color === color);
      if (matching >= 0) this.eligible = [matching, ...this.eligible.filter(index => index !== matching)];
      this.eligible.forEach(index => {
        const thumb = this.thumbs.find(button => button.dataset.galleryThumb === this.items[index].dataset.galleryItem);
        if (thumb) thumb.parentElement.appendChild(thumb);
      });
      this.showGallery(matching >= 0 ? matching : this.eligible[0]);
      this.error.hidden = true;
      if (changeUrl && this.dataset.updateUrl === 'true') { const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
    }
    showGallery(index, editor = false) {
      if (index < 0 || !this.items[index]) return;
      if (editor) { this.eligible = this.items.map((_, i) => i); this.thumbs.forEach(button => { button.hidden = false; }); }
      this.active = index;
      this.items.forEach((item, i) => { item.classList.toggle('is-active', i === index); item.setAttribute('aria-hidden', String(i !== index)); });
      this.thumbs.forEach(button => button.setAttribute('aria-current', String(button.dataset.galleryThumb === this.items[index].dataset.galleryItem)));
      const position = this.eligible.indexOf(index) + 1;
      this.querySelector('[data-gallery-count]').textContent = `${position} / ${this.eligible.length}`;
    }
    moveGallery(direction) {
      if (!this.eligible?.length) return;
      const current = this.eligible.indexOf(this.active);
      this.showGallery(this.eligible[(current + direction + this.eligible.length) % this.eligible.length]);
    }
    syncSticky() { if (this.sticky) this.sticky.hidden = !this.pastButton || this.atFooter; }
    async submit() {
      if (this.busy || !this.current.available) return;
      this.busy = true; this.error.hidden = true; this.add.disabled = true; this.label.textContent = this.data.adding;
      const stickyButton = this.querySelector('[data-sticky-add]'); stickyButton.disabled = true;
      const cart = document.querySelector('cart-drawer');
      const body = new FormData(this.form);
      if (cart?.getSectionsToRender) { body.append('sections', cart.getSectionsToRender().map(section => section.id).join(',')); body.append('sections_url', location.pathname); cart.setActiveElement(this.add); }
      const base = window.Shopify?.routes?.root || this.dataset.root || '/';
      try {
        const response = await fetch(base.replace(/\/?$/, '/') + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.data.error);
        if (cart?.renderContents && result.sections) { cart.classList.remove('is-empty'); cart.renderContents(result); }
        else location.assign(this.data.cart_url);
      } catch (error) { this.error.textContent = error.message || this.data.error; this.error.hidden = false; }
      finally { this.busy = false; this.add.disabled = !this.current.available; stickyButton.disabled = !this.current.available; this.label.textContent = this.current.available ? this.data.button : this.data.sold_out; }
    }
    disconnectedCallback() { this.events?.abort(); this.buttonObserver?.disconnect(); this.footerObserver?.disconnect(); }
  }
  if (!customElements.get('cozy-tabs')) customElements.define('cozy-tabs', CozyTabs);
  if (!customElements.get('cozy-product')) customElements.define('cozy-product', CozyProduct);
})();
